// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"0befb0eb","845":"5648be19"}[chunkId] + ".chunk.js";
};